export enum ListTypeEnum {
    both,
    contact,
    outlet,
    empty
}
